import React from 'react';
import propTypes from 'propTypes';
import * as v from 'common/validators';
import Button from 'common/components/Button';
import Label from 'components/shared/Label';
import * as c from '../appConstants';
import { Form, Field, Input, reduxForm, Submit } from 'common/components/Form';

const validate = values => ({
  price_per_pack: v.required(values.price_per_pack),
  cigarettes_per_day: v.required(values.cigarettes_per_day),
});

const CalculatorForm = ({ handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Label className="left h6 navy CalculatorForm__form-label">
        How much do you pay per pack of cigarettes?
      </Label>
      <div className="CalculatorForm__form-input">
        <Field
          name="price_per_pack"
          type="number"
          component={Input}
          step="any"
          label="$"
        />
      </div>
      <Label className="left h6 navy CalculatorForm__form-label">
        How many cigarettes do you usually smoke a day?
      </Label>
      <div className="CalculatorForm__form-input">
        <Field
          name="cigarettes_per_day"
          type="number"
          component={Input}
          step="any"
          label="#"
        />
      </div>
      <Submit className="CalculatorForm__submit">calculate</Submit>
    </Form>
  );
};

CalculatorForm.propTypes = {
  handleSubmit: propTypes.func.isRequired,
};

export default reduxForm({
  form: 'calculator',
  initialValues: {
    price_per_pack: c.DEFAULT_PACK_PRICE,
    cigarettes_per_day: c.DEFAULT_CIGS_SMOKED_DAILY,
  },
  validate,
})(CalculatorForm);



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/components/CalculatorForm.js